import Swal from "sweetalert2"
import { useNavigate } from 'react-router-dom'

export const redirectReducer = (state = {swal: false}, action)=>{
    switch (action.type) {
        case 'REDIRECT_INVALIDJWT':
            return {
                ...state,
                swal: true
            }
        case 'REDIRECT_RESET':
            return{
                ...state, swal: false
            }
        default:
            return state;
    }
}